import { createContext, useState } from "react";
import { merge } from "lodash";
import { layoutSettings } from "./layouts/Ide/settings";

const SettingsContextIde = createContext({
  updateSettings: () => {},
  settings: layoutSettings,
});

export const SettingsProviderIde = ({ settings, children }) => {
  const [currentSettings, setCurrentSettings] = useState(settings || layoutSettings);

  const handleUpdateSettings = (update = {}) => {
    const marged = merge({}, currentSettings, update);
    setCurrentSettings(marged);
  };

  return (
    <SettingsContextIde.Provider
      value={{ settings: currentSettings, updateSettings: handleUpdateSettings }} 
    >
      {children}
    </SettingsContextIde.Provider>
  );
};

export default SettingsContextIde; 
